import React from 'react';
import PropTypes from 'prop-types';
import CreditApplicationIncomplete
  from 'components/Credit24/SelfService/CreditApplicationStateAU/CreditApplicationIncomplete';
import CreditApplicationPending
  from 'components/Credit24/SelfService/CreditApplicationStateAU/CreditApplicationPending';
import CreditApplicationDeclined
  from 'components/Credit24/SelfService/CreditApplicationStateAU/CreditApplicationDeclined';

const propTypes = {
  creditApplicationState: PropTypes.string,
  logout: PropTypes.func.isRequired,
};

const CreditApplicationStateAU = ({ creditApplicationState, logout }) => {
  switch (creditApplicationState) {
    case 'OPEN':
      return <CreditApplicationIncomplete logout={logout} />;
    case 'ABANDONED':
      return <CreditApplicationIncomplete logout={logout} abandoned />;
    case 'PENDING':
      return <CreditApplicationPending logout={logout} />;
    case 'REJECTED':
      return <CreditApplicationDeclined logout={logout} />;
    default:
      return null;
  }
};

CreditApplicationStateAU.propTypes = propTypes;

export default CreditApplicationStateAU;
